import { z } from 'zod';
// =============================================================================
// Proposal action (shared by email and calendar propose-then-apply)
// =============================================================================
/**
 * Request body shared by every `POST .../proposal/confirm` and `POST
 * .../proposal/dismiss` route. Both name the exact match the caller is acting
 * on - see `CalendarClientMatchSchema.confirmedAt` / `EmailClientMatchSchema.
 * confirmedAt` for why "whatever is live now" is not a safe alternative.
 * Email's confirm route extends this with a `billable` answer
 * (`ConfirmProposalInputSchema`); calendar has no such second question and
 * uses this schema directly for both actions.
 */
export const ProposalActionInputSchema = z.object({
    matchId: z.uuid(),
});
export const ProposalActionResponseSchema = z.object({
    success: z.boolean(),
});
